import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// Translation resources
const resources = {
  en: {
    translation: {
      app: {
        common: {
          title: "Demo Usage Summary",
          usageTrackingAdmin: "Usage Tracking Admin",
          showTestingData: "Show testing data",
          searchPlaceholder: "Search demos by name, ID, or hostname",
        },
        navigation: {
          usage: "Usage Dashboard",
          allowlist: "Demo Allowlist",
        },
      },
      auth: {
        login: {
          title: "Login",
          email: "Email",
          password: "Password",
          button: "Login",
          emailPlaceholder: "Enter your email",
          passwordPlaceholder: "Enter your password",
        },
        midway: {
          signIn: "Sign in with Midway",
        },
        password: {
          change: "Change Password",
          changeTitle: "Change Password",
          new: "New Password",
          confirm: "Confirm Password",
          newPlaceholder: "Enter new password",
          confirmPlaceholder: "Confirm new password",
          description: "Must be at least 8 characters with uppercase, lowercase, numbers, and symbols",
          mismatch: "Passwords do not match",
          failed: "Password change failed. Please try again.",
        },
        common: {
          logout: "Logout",
          loginFailed: "Login failed. Please check your credentials.",
        },
      },
      table: {
        columns: {
          demoName: "Demo",
          demoId: "Demo ID",
          hostname: "Hostname",
          totalUsers: "Total Users",
          totalLogins: "Total Logins",
          userEmail: "User Email",
          lastLogin: "Last Login",
          opportunities: "Opportunities",
          loginMechanism: "Login Mechanism",
          userLanguage: "User Language",
          browserMode: "Browser Mode",
          opportunityId: "Opportunity ID",
          customerName: "Customer Name",
          language: "Language",
          mode: "Mode",
          notes: "Notes",
          loggedAt: "Logged At",
          location: "Location",
          country: "Country",
          timezone: "Timezone",
          localTime: "Local Time",
          contactSlack: "Contact on Slack",
        },
        empty: {
          noOpportunities: "No opportunities",
          noDemos: "No demos found",
          noUsers: "No users found for this demo",
        },
        values: {
          never: "Never",
        },
      },
      buttons: {
        common: {
          refresh: "Refresh",
        },
      },
      admin: {
        records: {
          detailedTitle: "Detailed Usage Records",
        },
        users: {
          title: "Users for Demo:",
        },
        "user-details": {
          title: "User Details:",
          "frontend-version": "Frontend Version",
        },
        opportunities: {
          title: "Opportunities",
        },
        headers: {
          usersForDemo: "Users for Demo:",
          userDetails: "User Details:",
        },
        allowlist: {
          title: "Demo Allowlist",
          description: "Manage which demos can send tracking data",
          addDemo: "Add Demo",
          demoId: "Demo ID",
          demoIdPlaceholder: "Enter demo ID (e.g., my-demo-123)",
          demoDescription: "Description",
          demoDescriptionPlaceholder: "Optional description",
          status: "Status",
          createdBy: "Created By",
          createdAt: "Created At",
          actions: "Actions",
          remove: "Remove",
          edit: "Edit",
          active: "Active",
          inactive: "Inactive",
          noDemos: "No demos in allowlist",
          confirmRemoveTitle: "Remove demo",
          confirmRemoveMessage: "Are you sure you want to remove {{demoId}} from the allowlist? This will prevent it from sending tracking data.",
          confirmRemoveButton: "Remove",
          cancelButton: "Cancel",
          editTitle: "Edit demo",
          editButton: "Save",
        },
      },
      attribution: {
        maxmind: "This product includes GeoLite2 Data created by MaxMind, available from",
      },
      "timezone-modal": {
        title: "Local Time",
        "current-time-in": "Current time in",
        "your-time": "Your current time",
        unknown: "Unknown",
      },
      "login-events": {
        modal: {
          title: "Login Events",
          loading: "Loading login events...",
          noEvents: "No login events found",
        },
        columns: {
          timestamp: "Timestamp",
        },
      },
    },
  },
  es: {
    translation: {
      app: {
        common: {
          title: "Resumen de Uso de Demostración",
          usageTrackingAdmin: "Administrador de Seguimiento de Uso",
          showTestingData: "Mostrar datos de prueba",
          searchPlaceholder: "Buscar demos por nombre, ID o nombre de host",
        },
        navigation: {
          usage: "Panel de Uso",
          allowlist: "Lista de Demos Permitidas",
        },
      },
      auth: {
        login: {
          title: "Iniciar Sesión",
          email: "Correo Electrónico",
          password: "Contraseña",
          button: "Iniciar Sesión",
          emailPlaceholder: "Ingrese su correo electrónico",
          passwordPlaceholder: "Ingrese su contraseña",
        },
        midway: {
          signIn: "Iniciar sesión con Midway",
        },
        password: {
          change: "Cambiar Contraseña",
          changeTitle: "Cambiar Contraseña",
          new: "Nueva Contraseña",
          confirm: "Confirmar Contraseña",
          newPlaceholder: "Ingrese nueva contraseña",
          confirmPlaceholder: "Confirme la contraseña",
          description: "Debe tener al menos 8 caracteres con mayúsculas, minúsculas, números y símbolos",
          mismatch: "Las contraseñas no coinciden",
          failed: "Error al cambiar la contraseña. Por favor, inténtelo de nuevo.",
        },
        common: {
          logout: "Cerrar Sesión",
          loginFailed: "Error al iniciar sesión. Por favor, verifique sus credenciales.",
        },
      },
      table: {
        columns: {
          demoName: "Demo",
          demoId: "ID de Demostración",
          hostname: "Nombre de Host",
          totalUsers: "Total de Usuarios",
          totalLogins: "Total de Inicios de Sesión",
          userEmail: "Correo del Usuario",
          lastLogin: "Último Inicio de Sesión",
          opportunities: "Oportunidades",
          loginMechanism: "Mecanismo de Inicio de Sesión",
          userLanguage: "Idioma del Usuario",
          browserMode: "Modo de Navegador",
          opportunityId: "ID de Oportunidad",
          customerName: "Nombre del Cliente",
          language: "Idioma",
          mode: "Modo",
          notes: "Notas",
          loggedAt: "Registrado En",
          location: "Ubicación",
          country: "País",
          timezone: "Zona Horaria",
          localTime: "Hora Local",
          contactSlack: "Contactar en Slack",
        },
        empty: {
          noOpportunities: "Sin oportunidades",
          noDemos: "No se encontraron demostraciones",
          noUsers: "No se encontraron usuarios para esta demostración",
        },
        values: {
          never: "Nunca",
        },
      },
      buttons: {
        common: {
          refresh: "Actualizar",
        },
      },
      admin: {
        records: {
          detailedTitle: "Registros de Uso Detallados",
        },
        users: {
          title: "Usuarios para Demo:",
        },
        "user-details": {
          title: "Detalles del Usuario:",
          "frontend-version": "Versión del Frontend",
        },
        opportunities: {
          title: "Oportunidades",
        },
        headers: {
          usersForDemo: "Usuarios para Demo:",
          userDetails: "Detalles del Usuario:",
        },
        allowlist: {
          title: "Lista de Demos Permitidas",
          description: "Administrar qué demos pueden enviar datos de seguimiento",
          addDemo: "Agregar Demo",
          demoId: "ID de Demo",
          demoIdPlaceholder: "Ingrese ID de demo (ej., mi-demo-123)",
          demoDescription: "Descripción",
          demoDescriptionPlaceholder: "Descripción opcional",
          status: "Estado",
          createdBy: "Creado Por",
          createdAt: "Creado En",
          actions: "Acciones",
          remove: "Eliminar",
          edit: "Editar",
          active: "Activo",
          inactive: "Inactivo",
          noDemos: "No hay demos en la lista",
          confirmRemoveTitle: "Eliminar demo",
          confirmRemoveMessage: "¿Está seguro de que desea eliminar {{demoId}} de la lista? Esto impedirá que envíe datos de seguimiento.",
          confirmRemoveButton: "Eliminar",
          cancelButton: "Cancelar",
          editTitle: "Editar demo",
          editButton: "Guardar",
        },
      },
      attribution: {
        maxmind: "Este producto incluye datos GeoLite2 creados por MaxMind, disponibles en",
      },
      "timezone-modal": {
        title: "Hora Local",
        "current-time-in": "Hora actual en",
        "your-time": "Tu hora actual",
        unknown: "Desconocido",
      },
      "login-events": {
        modal: {
          title: "Eventos de Inicio de Sesión",
          loading: "Cargando eventos de inicio de sesión...",
          noEvents: "No se encontraron eventos de inicio de sesión",
        },
        columns: {
          timestamp: "Fecha y Hora",
        },
      },
    },
  },
  ja: {
    translation: {
      app: {
        common: {
          title: "デモ使用状況サマリー",
          usageTrackingAdmin: "使用状況追跡管理",
          showTestingData: "テストデータを表示",
          searchPlaceholder: "名前、ID、またはホスト名でデモを検索",
        },
        navigation: {
          usage: "使用状況ダッシュボード",
          allowlist: "デモ許可リスト",
        },
      },
      auth: {
        login: {
          title: "ログイン",
          email: "メールアドレス",
          password: "パスワード",
          button: "ログイン",
          emailPlaceholder: "メールアドレスを入力",
          passwordPlaceholder: "パスワードを入力",
        },
        midway: {
          signIn: "Midwayでサインイン",
        },
        password: {
          change: "パスワード変更",
          changeTitle: "パスワード変更",
          new: "新しいパスワード",
          confirm: "パスワード確認",
          newPlaceholder: "新しいパスワードを入力",
          confirmPlaceholder: "パスワードを確認",
          description: "大文字、小文字、数字、記号を含む8文字以上である必要があります",
          mismatch: "パスワードが一致しません",
          failed: "パスワードの変更に失敗しました。もう一度お試しください。",
        },
        common: {
          logout: "ログアウト",
          loginFailed: "ログインに失敗しました。認証情報を確認してください。",
        },
      },
      table: {
        columns: {
          demoName: "デモ",
          demoId: "デモID",
          hostname: "ホスト名",
          totalUsers: "総ユーザー数",
          totalLogins: "総ログイン数",
          userEmail: "ユーザーメール",
          lastLogin: "最終ログイン",
          opportunities: "商談",
          loginMechanism: "ログイン方式",
          userLanguage: "ユーザー言語",
          browserMode: "ブラウザモード",
          opportunityId: "商談ID",
          customerName: "顧客名",
          language: "言語",
          mode: "モード",
          notes: "メモ",
          loggedAt: "記録日時",
          location: "場所",
          country: "国",
          timezone: "タイムゾーン",
          localTime: "現地時間",
          contactSlack: "Slackで連絡",
        },
        empty: {
          noOpportunities: "商談なし",
          noDemos: "デモが見つかりません",
          noUsers: "このデモのユーザーが見つかりません",
        },
        values: {
          never: "なし",
        },
      },
      buttons: {
        common: {
          refresh: "更新",
        },
      },
      admin: {
        records: {
          detailedTitle: "詳細な使用記録",
        },
        users: {
          title: "デモのユーザー：",
        },
        "user-details": {
          title: "ユーザー詳細：",
          "frontend-version": "フロントエンドバージョン",
        },
        opportunities: {
          title: "商談",
        },
        headers: {
          usersForDemo: "デモのユーザー：",
          userDetails: "ユーザー詳細：",
        },
        allowlist: {
          title: "デモ許可リスト",
          description: "追跡データを送信できるデモを管理",
          addDemo: "デモを追加",
          demoId: "デモID",
          demoIdPlaceholder: "デモIDを入力（例：my-demo-123）",
          demoDescription: "説明",
          demoDescriptionPlaceholder: "オプションの説明",
          status: "ステータス",
          createdBy: "作成者",
          createdAt: "作成日時",
          actions: "アクション",
          remove: "削除",
          edit: "編集",
          active: "アクティブ",
          inactive: "非アクティブ",
          noDemos: "許可リストにデモがありません",
          confirmRemoveTitle: "デモを削除",
          confirmRemoveMessage: "{{demoId}}を許可リストから削除してもよろしいですか？追跡データの送信ができなくなります。",
          confirmRemoveButton: "削除",
          cancelButton: "キャンセル",
          editTitle: "デモを編集",
          editButton: "保存",
        },
      },
      attribution: {
        maxmind: "この製品には、MaxMindが作成したGeoLite2データが含まれています。詳細は",
      },
      "timezone-modal": {
        title: "現地時間",
        "current-time-in": "現在時刻：",
        "your-time": "あなたの現在時刻",
        unknown: "不明",
      },
      "login-events": {
        modal: {
          title: "ログインイベント",
          loading: "ログインイベントを読み込み中...",
          noEvents: "ログインイベントが見つかりません",
        },
        columns: {
          timestamp: "日時",
        },
      },
    },
  },
  ko: {
    translation: {
      app: {
        common: {
          title: "데모 사용 요약",
          usageTrackingAdmin: "사용 추적 관리자",
          showTestingData: "테스트 데이터 표시",
          searchPlaceholder: "이름, ID 또는 호스트명으로 데모 검색",
        },
        navigation: {
          usage: "사용 대시보드",
          allowlist: "데모 허용 목록",
        },
      },
      auth: {
        login: {
          title: "로그인",
          email: "이메일",
          password: "비밀번호",
          button: "로그인",
          emailPlaceholder: "이메일을 입력하세요",
          passwordPlaceholder: "비밀번호를 입력하세요",
        },
        midway: {
          signIn: "Midway로 로그인",
        },
        password: {
          change: "비밀번호 변경",
          changeTitle: "비밀번호 변경",
          new: "새 비밀번호",
          confirm: "비밀번호 확인",
          newPlaceholder: "새 비밀번호를 입력하세요",
          confirmPlaceholder: "비밀번호를 확인하세요",
          description: "대문자, 소문자, 숫자 및 기호를 포함한 8자 이상이어야 합니다",
          mismatch: "비밀번호가 일치하지 않습니다",
          failed: "비밀번호 변경에 실패했습니다. 다시 시도해 주세요.",
        },
        common: {
          logout: "로그아웃",
          loginFailed: "로그인에 실패했습니다. 자격 증명을 확인하세요.",
        },
      },
      table: {
        columns: {
          demoName: "데모",
          demoId: "데모 ID",
          hostname: "호스트명",
          totalUsers: "총 사용자 수",
          totalLogins: "총 로그인 수",
          userEmail: "사용자 이메일",
          lastLogin: "마지막 로그인",
          opportunities: "기회",
          loginMechanism: "로그인 방식",
          userLanguage: "사용자 언어",
          browserMode: "브라우저 모드",
          opportunityId: "기회 ID",
          customerName: "고객명",
          language: "언어",
          mode: "모드",
          notes: "메모",
          loggedAt: "기록 시간",
          location: "위치",
          country: "국가",
          timezone: "시간대",
          localTime: "현지 시간",
          contactSlack: "Slack으로 연락",
        },
        empty: {
          noOpportunities: "기회 없음",
          noDemos: "데모를 찾을 수 없습니다",
          noUsers: "이 데모의 사용자를 찾을 수 없습니다",
        },
        values: {
          never: "없음",
        },
      },
      buttons: {
        common: {
          refresh: "새로 고침",
        },
      },
      admin: {
        records: {
          detailedTitle: "상세 사용 기록",
        },
        users: {
          title: "데모 사용자:",
        },
        "user-details": {
          title: "사용자 세부정보:",
          "frontend-version": "프론트엔드 버전",
        },
        opportunities: {
          title: "기회",
        },
        headers: {
          usersForDemo: "데모 사용자:",
          userDetails: "사용자 세부정보:",
        },
        allowlist: {
          title: "데모 허용 목록",
          description: "추적 데이터를 보낼 수 있는 데모 관리",
          addDemo: "데모 추가",
          demoId: "데모 ID",
          demoIdPlaceholder: "데모 ID 입력 (예: my-demo-123)",
          demoDescription: "설명",
          demoDescriptionPlaceholder: "선택적 설명",
          status: "상태",
          createdBy: "생성자",
          createdAt: "생성 시간",
          actions: "작업",
          remove: "제거",
          edit: "편집",
          active: "활성",
          inactive: "비활성",
          noDemos: "허용 목록에 데모가 없습니다",
          confirmRemoveTitle: "데모 제거",
          confirmRemoveMessage: "{{demoId}}을(를) 허용 목록에서 제거하시겠습니까? 추적 데이터 전송이 차단됩니다.",
          confirmRemoveButton: "제거",
          cancelButton: "취소",
          editTitle: "데모 편집",
          editButton: "저장",
        },
      },
      attribution: {
        maxmind: "이 제품에는 MaxMind에서 제작한 GeoLite2 데이터가 포함되어 있습니다. 자세한 내용은",
      },
      "timezone-modal": {
        title: "현지 시간",
        "current-time-in": "현재 시간:",
        "your-time": "귀하의 현재 시간",
        unknown: "알 수 없음",
      },
      "login-events": {
        modal: {
          title: "로그인 이벤트",
          loading: "로그인 이벤트 로딩 중...",
          noEvents: "로그인 이벤트를 찾을 수 없습니다",
        },
        columns: {
          timestamp: "타임스탬프",
        },
      },
    },
  },
  fr: {
    translation: {
      app: {
        common: {
          title: "Résumé d'utilisation des démos",
          usageTrackingAdmin: "Admin de suivi d'utilisation",
          showTestingData: "Afficher les données de test",
          searchPlaceholder: "Rechercher par nom, ID ou nom d'hôte",
        },
        navigation: {
          usage: "Tableau de bord",
          allowlist: "Liste des démos autorisées",
        },
      },
      auth: {
        login: {
          title: "Connexion",
          email: "E-mail",
          password: "Mot de passe",
          button: "Se connecter",
          emailPlaceholder: "Entrez votre e-mail",
          passwordPlaceholder: "Entrez votre mot de passe",
        },
        midway: {
          signIn: "Se connecter avec Midway",
        },
        password: {
          change: "Changer le mot de passe",
          changeTitle: "Changer le mot de passe",
          new: "Nouveau mot de passe",
          confirm: "Confirmer le mot de passe",
          newPlaceholder: "Entrez le nouveau mot de passe",
          confirmPlaceholder: "Confirmez le mot de passe",
          description: "Doit contenir au moins 8 caractères avec majuscules, minuscules, chiffres et symboles",
          mismatch: "Les mots de passe ne correspondent pas",
          failed: "Échec du changement de mot de passe. Veuillez réessayer.",
        },
        common: {
          logout: "Déconnexion",
          loginFailed: "Échec de la connexion. Veuillez vérifier vos identifiants.",
        },
      },
      table: {
        columns: {
          demoName: "Démo",
          demoId: "ID de démo",
          hostname: "Nom d'hôte",
          totalUsers: "Utilisateurs totaux",
          totalLogins: "Connexions totales",
          userEmail: "E-mail utilisateur",
          lastLogin: "Dernière connexion",
          opportunities: "Opportunités",
          loginMechanism: "Mécanisme de connexion",
          userLanguage: "Langue utilisateur",
          browserMode: "Mode navigateur",
          opportunityId: "ID d'opportunité",
          customerName: "Nom du client",
          language: "Langue",
          mode: "Mode",
          notes: "Notes",
          loggedAt: "Enregistré le",
          location: "Emplacement",
          country: "Pays",
          timezone: "Fuseau horaire",
          localTime: "Heure locale",
          contactSlack: "Contacter sur Slack",
        },
        empty: {
          noOpportunities: "Aucune opportunité",
          noDemos: "Aucune démo trouvée",
          noUsers: "Aucun utilisateur trouvé pour cette démo",
        },
        values: {
          never: "Jamais",
        },
      },
      buttons: {
        common: {
          refresh: "Actualiser",
        },
      },
      admin: {
        records: {
          detailedTitle: "Enregistrements d'utilisation détaillés",
        },
        users: {
          title: "Utilisateurs de la démo :",
        },
        "user-details": {
          title: "Détails utilisateur :",
          "frontend-version": "Version frontend",
        },
        opportunities: {
          title: "Opportunités",
        },
        headers: {
          usersForDemo: "Utilisateurs de la démo :",
          userDetails: "Détails utilisateur :",
        },
        allowlist: {
          title: "Liste des démos autorisées",
          description: "Gérer les démos autorisées à envoyer des données",
          addDemo: "Ajouter une démo",
          demoId: "ID de démo",
          demoIdPlaceholder: "Entrez l'ID de démo (ex. : ma-demo-123)",
          demoDescription: "Description",
          demoDescriptionPlaceholder: "Description optionnelle",
          status: "Statut",
          createdBy: "Créé par",
          createdAt: "Créé le",
          actions: "Actions",
          remove: "Supprimer",
          edit: "Modifier",
          active: "Actif",
          inactive: "Inactif",
          noDemos: "Aucune démo dans la liste",
          confirmRemoveTitle: "Supprimer la démo",
          confirmRemoveMessage: "Êtes-vous sûr de vouloir supprimer {{demoId}} de la liste ? Cela empêchera l'envoi de données de suivi.",
          confirmRemoveButton: "Supprimer",
          cancelButton: "Annuler",
          editTitle: "Modifier la démo",
          editButton: "Enregistrer",
        },
      },
      attribution: {
        maxmind: "Ce produit inclut des données GeoLite2 créées par MaxMind, disponibles sur",
      },
      "timezone-modal": {
        title: "Heure locale",
        "current-time-in": "Heure actuelle à",
        "your-time": "Votre heure actuelle",
        unknown: "Inconnu",
      },
      "login-events": {
        modal: {
          title: "Événements de connexion",
          loading: "Chargement des événements de connexion...",
          noEvents: "Aucun événement de connexion trouvé",
        },
        columns: {
          timestamp: "Horodatage",
        },
      },
    },
  },
  zh: {
    translation: {
      app: {
        common: {
          title: "演示使用摘要",
          usageTrackingAdmin: "使用跟踪管理",
          showTestingData: "显示测试数据",
          searchPlaceholder: "按名称、ID或主机名搜索演示",
        },
        navigation: {
          usage: "使用仪表板",
          allowlist: "演示许可列表",
        },
      },
      auth: {
        login: {
          title: "登录",
          email: "电子邮件",
          password: "密码",
          button: "登录",
          emailPlaceholder: "输入您的电子邮件",
          passwordPlaceholder: "输入您的密码",
        },
        midway: {
          signIn: "使用Midway登录",
        },
        password: {
          change: "更改密码",
          changeTitle: "更改密码",
          new: "新密码",
          confirm: "确认密码",
          newPlaceholder: "输入新密码",
          confirmPlaceholder: "确认新密码",
          description: "必须至少8个字符，包含大写、小写、数字和符号",
          mismatch: "密码不匹配",
          failed: "密码更改失败，请重试。",
        },
        common: {
          logout: "退出登录",
          loginFailed: "登录失败，请检查您的凭据。",
        },
      },
      table: {
        columns: {
          demoName: "演示",
          demoId: "演示ID",
          hostname: "主机名",
          totalUsers: "总用户数",
          totalLogins: "总登录次数",
          userEmail: "用户邮箱",
          lastLogin: "最后登录",
          opportunities: "商机",
          loginMechanism: "登录方式",
          userLanguage: "用户语言",
          browserMode: "浏览器模式",
          opportunityId: "商机ID",
          customerName: "客户名称",
          language: "语言",
          mode: "模式",
          notes: "备注",
          loggedAt: "记录时间",
          location: "位置",
          country: "国家",
          timezone: "时区",
          localTime: "当地时间",
          contactSlack: "通过Slack联系",
        },
        empty: {
          noOpportunities: "暂无商机",
          noDemos: "未找到演示",
          noUsers: "未找到此演示的用户",
        },
        values: {
          never: "从未",
        },
      },
      buttons: {
        common: {
          refresh: "刷新",
        },
      },
      admin: {
        records: {
          detailedTitle: "详细使用记录",
        },
        users: {
          title: "演示用户：",
        },
        "user-details": {
          title: "用户详情：",
          "frontend-version": "前端版本",
        },
        opportunities: {
          title: "商机",
        },
        headers: {
          usersForDemo: "演示用户：",
          userDetails: "用户详情：",
        },
        allowlist: {
          title: "演示许可列表",
          description: "管理可以发送跟踪数据的演示",
          addDemo: "添加演示",
          demoId: "演示ID",
          demoIdPlaceholder: "输入演示ID（例如：my-demo-123）",
          demoDescription: "描述",
          demoDescriptionPlaceholder: "可选描述",
          status: "状态",
          createdBy: "创建者",
          createdAt: "创建时间",
          actions: "操作",
          remove: "移除",
          edit: "编辑",
          active: "活跃",
          inactive: "非活跃",
          noDemos: "许可列表中没有演示",
          confirmRemoveTitle: "移除演示",
          confirmRemoveMessage: "确定要从许可列表中移除 {{demoId}} 吗？这将阻止其发送跟踪数据。",
          confirmRemoveButton: "移除",
          cancelButton: "取消",
          editTitle: "编辑演示",
          editButton: "保存",
        },
      },
      attribution: {
        maxmind: "本产品包含由MaxMind创建的GeoLite2数据，详情请访问",
      },
      "timezone-modal": {
        title: "当地时间",
        "current-time-in": "当前时间：",
        "your-time": "您的当前时间",
        unknown: "未知",
      },
      "login-events": {
        modal: {
          title: "登录事件",
          loading: "正在加载登录事件...",
          noEvents: "未找到登录事件",
        },
        columns: {
          timestamp: "时间戳",
        },
      },
    },
  },
};

// Detect browser language
const browserLanguage = navigator.language || navigator.userLanguage;
const defaultLanguage = browserLanguage.startsWith("es")
  ? "es"
  : browserLanguage.startsWith("ja")
    ? "ja"
    : browserLanguage.startsWith("ko")
      ? "ko"
      : browserLanguage.startsWith("fr")
        ? "fr"
        : browserLanguage.startsWith("zh")
          ? "zh"
          : "en";

i18n.use(initReactI18next).init({
  resources,
  lng: defaultLanguage, // Use detected browser language
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
